import { GivelifyInfo, GivelifyLabel } from '@givelify/givelify-ui';
import { DesignTokens } from '@givelify/ui';
import { styled } from '@mui/material/styles';

export const FormWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 856,
});

export const TextFieldsWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginBottom: 40,
});

export const DateFieldsWrapper = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto 1fr',
    alignItems: 'center',
    gap: 8,
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: 'auto 1fr',
    },
}));

export const DateFieldLabelWrapper = styled('div')({
    marginBottom: 26,
});

export const DatesWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: 24,
    marginBottom: 24,
    marginTop: 16,
    '& > *': {
        flex: 1,
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
    },
}));

export const ExtraMarginBottom = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        marginBottom: 2,
    },
}));

export const AmountControlsWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 16,
    gap: 24,
    '& > *': {
        flex: 1,
        width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'start',
    },
}));

export const RadioButtonsWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& > *': {
        flex: 1,
        width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'start',
    },
    [theme.breakpoints.up('md')]: {
        marginBottom: 24,
    },
}));

export const ButtonsWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    gap: 32,
    marginTop: 56,
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse',
        gap: 16,
        marginTop: 40,
    },
}));

export const DeleteButtonWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    [theme.breakpoints.up('md')]: {
        marginBottom: 32,
    },
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        order: 100,
        marginTop: 32,
    },
}));

export const GoalHintWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    marginTop: 5,
    marginBottom: 5,
    paddingLeft: 16,
    paddingRight: 16,
});

export const GoalHintLink = styled(GivelifyLabel)({
    color: DesignTokens.color.textAccentPressed,
});

export const GoalHintTooltip = styled(GivelifyInfo)({
    height: 14,
});

export const GoalHelperText = styled(GivelifyLabel)({
    whiteSpace: 'pre',
});
